import { goToPageReplaceQueryStringParameter } from './global.js';

$(document).ready(function(){
	bindProductEvents();
	loadPrices();
	bindGraduatedPricesEvent();
	showHideComparator();
	initializeComparator();	
	$('[data-toggle="tooltip"]').tooltip();

	//Mobile filters
	$(".mobile-filter-btn").unbind("click");
	$(".mobile-filter-btn").click(function(){
		$('#mobile-filters-modal .modal-body:first').html($("#product-filters").html());
		$('#mobile-filters-modal .modal-header h5:first').html($("#product-filters-title").html());
		
		bindProductEvents();
		
		$(".filter-products-btn").unbind("click");
		$(".filter-products-btn").click(function(){
			var priceFilterFromValue = $("#mobile-filters-modal .price-filter-container").find(".price-from:first").val();
			var priceFilterToValue = $("#mobile-filters-modal .price-filter-container").find(".price-to:first").val();
			
			if(priceFilterFromValue == undefined){
				priceFilterFromValue = 0;
			}
			
			if(priceFilterToValue == undefined){
				priceFilterToValue = 0;
			}
			
			var search = $("#mobile-filters-modal .product-search-filter").val();
			if(search.length > 0){
				goToPageReplaceQueryStringParameter("search=" + $("#mobile-filters-modal .product-search-filter").val(), false);
			}
			
			goToPageReplaceQueryStringParameter("Price=" + priceFilterFromValue + "-" + priceFilterToValue, false);
			
			location.reload();
		});
		
		$('#mobile-filters-modal').modal();
	});
});

$(window).resize(function() {
  initializeComparator();
});

function loadPrices(){
	if($('.product-price-container').length > 0){
		var firstPreloader = $('.product-price-container .preloader:first');
		var otherPreloaders = $('.product-price-container .preloader:not(:first)');
		
		//Load first
		loadPrice(firstPreloader, function(){
			//Load other prices
			$.each(otherPreloaders, function() {		
				loadPrice($(this), undefined, true);
			});
		}, true);
	}
}

function loadPrice(preloader, callBackFunction, reloadOnFail){
	var priceTemplate = $("#product-price-template").html();	

	$.get('/api/productprice?productcode=' + encodeURIComponent(preloader.attr('product-code')) + '&isnewprice=' + preloader.attr('is-new-price'), function(data) {
		if(data.previousBruto == ""){
			priceTemplate = priceTemplate.replace('"previous-bruto-price"', '"previous-bruto-price hide"');
		}
		else{
			priceTemplate = priceTemplate.replace('{previous-bruto}', data.previousBruto);
		}

		if(data.bruto == ""){
			priceTemplate = priceTemplate.replace('"bruto-price"', '"bruto-price hide"');
		}
		else{
			priceTemplate = priceTemplate.replace('{bruto}', data.bruto);
		}

		if(data.discount == ""){
			priceTemplate = priceTemplate.replace('"discount-price"', '"discount-price hide"');
		}
		else{
			priceTemplate = priceTemplate.replace('{discount}', data.discount);
		}

		if(data.netto == ""){
			priceTemplate = priceTemplate.replace('"netto-price"', '"netto-price hide"');
		}
		else{
			priceTemplate = priceTemplate.replace('{netto}', data.netto);
		}
		
		if(!data.showGraduatedPriceIcon){
			priceTemplate = priceTemplate.replace('"graduated-prices"', '"graduated-prices hide"');
			priceTemplate = priceTemplate.replace('"graduated-prices-spacer hide"', '"graduated-prices-spacer"');
		}else{
			priceTemplate = priceTemplate.replace('product-code=""', 'product-code="' + preloader.attr('product-code') + '"');
		}
		
		if(!data.showDiscountOnDemand){
			priceTemplate = priceTemplate.replace('"discount-price-on-demand"', '"discount-price-on-demand hide"');
		}else{
			priceTemplate = priceTemplate.replace('"discount-price"', '"discount-price hide"');
		}

		preloader.replaceWith(priceTemplate);	
		bindGraduatedPricesEvent();
		$('[data-toggle="tooltip"]').tooltip();
		
		if(callBackFunction != undefined){
			callBackFunction();	
		}
	}).fail(function() {
		if(reloadOnFail == true){
			loadPrice(preloader, callBackFunction, false);
		}
	});
}

function bindGraduatedPricesEvent(){
	$('.graduated-prices').unbind('click');
	$('.graduated-prices').click(function(e){
		$.get('/api/productgraduatedprices?productcode=' + encodeURIComponent($(this).attr('product-code')), function(data) {
			$('#product-graduated-prices-modal').find(".modal-content").html(data);
			$('#product-graduated-prices-modal').modal();
		});
		
		e.preventDefault();
	});
}

function roundValue(value, step){
	return Math.round(value / step) * step;
}

function getProductsToCompare(){
	return JSON.parse(localStorage.getItem(personalisedCatalogueActive ? 'productsToComparePersonalisedCatalogue' : 'productsToCompare'));
}

function setProductsToCompare(productsToCompare){
	localStorage.setItem(personalisedCatalogueActive ? 'productsToComparePersonalisedCatalogue' : 'productsToCompare', JSON.stringify(productsToCompare));
}

function removeProductFromComparator(productId){
	var productsToCompare = getProductsToCompare();
	
	if(productsToCompare == null){
		return;
	}
	
	productsToCompare = jQuery.grep(productsToCompare, function(value) {
	  return value != productId;
	});
	
	setProductsToCompare(productsToCompare);
	showHideComparator();
}

function addProductToComparator(productId){
	var productsToCompare = getProductsToCompare();
	
	if(productsToCompare == null){
		productsToCompare = [];
	}
	
	removeProductFromComparator(productId);
	productsToCompare[productsToCompare.length] = productId;
	
	setProductsToCompare(productsToCompare);
	showHideComparator();
}

function showHideComparator(){
	var productsToCompare = getProductsToCompare();
	if(productsToCompare != null){
		$("#comparator .comparator-total").html(productsToCompare.length);
		$(".comparator-product-id").remove();
		
		for(var i = 0; i < productsToCompare.length; i++)
		{
			$("#comparator-form").prepend('<input class="comparator-product-id" name="Ids['+i+']" type="hidden" value="'+ productsToCompare[i] +'">');
			$('input[product-id='+ productsToCompare[i] +']').prop("checked", true);
		}
		
		if(productsToCompare.length > 0){
			$("#comparator").show();
		}else{
			$("#comparator").hide();
		}
		
		if(productsToCompare.length > 0 && $("#comparator-container").length > 0){
			if($("#comparator-container").find(".row").length == 0){
				loadProductsToCompare();
			}
		}
	}else{
		$("#comparator").hide();
	}
}

function initializeComparator(){
	var firstColumnWidth = $(".col-comparator-first:first").width();
	var columnWidth = $(".col-comparator:first").width();
	var columnCount = $(".product-block-img-container").length;
				
	$(".row.comparator").width((firstColumnWidth + (columnWidth * columnCount)) * 1.2);
	$("#comparator-overlay").width(firstColumnWidth + 35);
	$("#comparator-overlay").height($("#comparator-container").height() - 20);
}

function bindComparatorEvents(){
	$('.checkbox-product-compare').unbind('click');
	$('.checkbox-product-compare').click(function(e){
		var productId = $(this).attr("product-id");
		
		if($(this).is(':checked'))
		{
			addProductToComparator(productId);
		}
		else
		{
			removeProductFromComparator(productId);
		}
	});
	
	$('.remove-comparator-product').unbind('click');
	$('.remove-comparator-product').click(function(e){
		removeProductFromComparator($(this).attr("product-id"));
		loadProductsToCompare();
	});
	
	$('.checkbox-show-differences').unbind('click');
	$('.checkbox-show-differences').click(function(e){		
		if($(this).is(':checked')){
			$(".row-is-equal").hide();
			$(".description-is-equal").hide();
		}
		else{
			$(".row-is-equal").show();
			$(".description-is-equal").show();
		}
		
		initializeComparator();
	});
}

function loadProductsToCompare(){
	var productsToCompare = getProductsToCompare();
				
	$.ajax({
		type: 'POST',
		url: 'api/getProductsToCompare',
		data: { productIdsToCompare: productsToCompare },
		success: function(data){					
			$("#comparator-container").html(data);
			
			bindProductEvents();
			loadPrices();
			showHideComparator();
			initializeComparator();	
			$('[data-toggle="tooltip"]').tooltip();
		}
	});
}

export function bindProductEvents(queryString, reloadPage){
	//Product filtering
	$('.product-filter').change(function() {
		var startQueryString = "filters=";
		var queryString = startQueryString;
		var parentContainer = "#product-filters";
		var reloadPage = true;
		
		if ($('div#mobile-filters-modal').has($(this)).length) {
			reloadPage = false;	
			parentContainer	= "#mobile-filters-modal";		
		}
		
		$(parentContainer + ' .product-filter:checked').each(function () {
			queryString += $(this).attr("filter-id") + ",";
		});
		

		if(queryString == startQueryString){
			goToPageReplaceQueryStringParameter(queryString, reloadPage);
		}else{
			goToPageReplaceQueryStringParameter(queryString.substr(0, queryString.length-1), reloadPage);
		}
    });
	
	//Clear all filters
	$('.clear-filters-button').click(function() {
		var reloadPage = true;
		
		if ($('div#mobile-filters-modal').has($(this)).length) {
			reloadPage = false;	
		}
		
		$.each($(".product-filter-on-property"), function() {	
			if($(this).is(":checked")){		
				goToPageReplaceQueryStringParameter($(this).attr("filter-on") + "=false", false);
			}
		});
		
		if(!reloadPage){
			$(".selected-filters-container").remove();
		}
		goToPageReplaceQueryStringParameter("filters=", reloadPage);
	});
	
	//Clear filter
	$('.clear-filter-button').click(function() {
		var parentContainer = "#product-filters";
		var reloadPage = true;
		
		if ($('div#mobile-filters-modal').has($(this)).length) {
			reloadPage = false;	
			parentContainer	= "#mobile-filters-modal";		
		}
		
		if(!reloadPage){
			$(this).closest("li").remove();
		}
		
		if($(".selected-filters-container:first ul li").length == 1){
			$(".selected-filters-container").remove();
		}
		
		if($(this).attr("filter-to-clear") != undefined){
			var filterToClear = $(this).attr("filter-to-clear");
			goToPageReplaceQueryStringParameter(filterToClear + "=false", reloadPage);
		}else if($(this).attr("filters-to-clear") != undefined){
			var filterIdsToClear = $(this).attr("filters-to-clear").split(',');
			var startQueryString = "filters=";
			var queryString = startQueryString;
			
			$(parentContainer + ' .product-filter:checked').each(function () {
				var filterId = $(this).attr("filter-id");
				if(!filterIdsToClear.includes(filterId)){
					queryString += filterId + ",";
				}
			});
			
			if(queryString == startQueryString){
				goToPageReplaceQueryStringParameter(queryString, reloadPage);
			}else{
				goToPageReplaceQueryStringParameter(queryString.substr(0, queryString.length-1), reloadPage);
			}
		}
	});
	
	//Product search
	$('.product-search-filter').on('search', function(e) {
		var reloadPage = true;
		if ($('div#mobile-filters-modal').has($(this)).length) {
			reloadPage = false;	
		}
		goToPageReplaceQueryStringParameter("sort=", false);
		goToPageReplaceQueryStringParameter("search=" + $(this).val(), reloadPage);
    });
	
	//Product search when clicking button
	$(".product-search-filter-btn").unbind("click");
	$(".product-search-filter-btn").click(function(){
		var reloadPage = true;
		if ($('div#mobile-filters-modal').has($(this)).length) {
			reloadPage = false;	
		}
		goToPageReplaceQueryStringParameter("sort=", false);
		goToPageReplaceQueryStringParameter("search=" + $($(this).attr("linked-input")).val(), reloadPage);
	});
	
	//Product property filtering (true/false)
	$('.product-filter-on-property').change(function() {
		var reloadPage = true;
		if ($('div#mobile-filters-modal').has($(this)).length) {
			reloadPage = false;	
		}
		
		if($(this).is(":checked")){
			goToPageReplaceQueryStringParameter($(this).attr("filter-on") + "=true", reloadPage);
		}else{
			goToPageReplaceQueryStringParameter($(this).attr("filter-on") + "=false", reloadPage);
		}
    });
	
	//Price filter
	$('.product-price-filter-btn').unbind("click");
	$('.product-price-filter-btn').click(function() {
		var reloadPage = true;
		if ($('div#mobile-filters-modal').has($(this)).length) {
			reloadPage = false;	
		}
		
		var priceFilterFromValue = $(this).closest(".price-filter-container").find(".price-from:first").val();
		var priceFilterToValue = $(this).closest(".price-filter-container").find(".price-to:first").val();
		
		goToPageReplaceQueryStringParameter("Price=" + priceFilterFromValue + "-" + priceFilterToValue, reloadPage);
    });
	
	//Show/hide product filters
	$(".product-filter-group-container .show-more-button").unbind("click");
	$(".product-filter-group-container .show-more-button").click(function(){
		var filterGroupContainer = $(this).closest(".product-filter-group-container");
		filterGroupContainer.find("li.hide").attr("hide-when-show-less", true);
		filterGroupContainer.find("p.hide").attr("hide-when-show-less", true)
		filterGroupContainer.find("li").removeClass("hide");
		filterGroupContainer.find("p").removeClass("hide");
		filterGroupContainer.find(".show-less-button").removeClass("hide");
		$(this).addClass("hide");
	});
	
	$(".product-filter-group-container .show-less-button").unbind("click");
	$(".product-filter-group-container .show-less-button").click(function(){
		var filterGroupContainer = $(this).closest(".product-filter-group-container");
		filterGroupContainer.find("li[hide-when-show-less=true]").addClass("hide");
		filterGroupContainer.find("p[hide-when-show-less=true]").addClass("hide");
		filterGroupContainer.find(".show-more-button").removeClass("hide");
		$(this).addClass("hide");
	});
	
	
	//Show/hide product filter groups
	$(".show-all-filters-button").unbind("click");
	$(".show-all-filters-button").click(function(){
		var parentContainer = "#product-filters";

		if ($('div#mobile-filters-modal').has($(this)).length) {
			parentContainer	= "#mobile-filters-modal";		
		}
		
		$(this).addClass("hide");
		$(parentContainer + " .hide-additional-filters-button").removeClass("hide");
		$(parentContainer + " .product-filter-group-container.hide").removeClass("hide");
	});
	
	$(".hide-additional-filters-button").unbind("click");
	$(".hide-additional-filters-button").click(function(){
		var parentContainer = "#product-filters";

		if ($('div#mobile-filters-modal').has($(this)).length) {
			parentContainer	= "#mobile-filters-modal";		
		}
		
		$(this).addClass("hide");
		$(parentContainer + " .show-all-filters-button").removeClass("hide");
		$(parentContainer + " .product-filter-group-container[additional-filter=true]").addClass("hide");
	});
	
	//Product counter plus/min
	$(".counter-container").find(".btn.min").unbind("click");
	$(".counter-container").find(".btn.min").click(function(e){
		var counterContainer = $(this).closest('.counter-container');
		var currentValue = parseInt(counterContainer.find('input[product-code]:first').val());
		var minimumAmount = parseInt(counterContainer.attr('min-amount'));
		
		if(currentValue > minimumAmount){
			var newValue = roundValue(currentValue-minimumAmount, minimumAmount);
			if(counterContainer.find('form').length > 0){
				$(this).parent().submit();
			}else{
				$(this).closest('.counter-container').find('input[product-code]:first').val(newValue);
			}
		}
		
		e.preventDefault();
	});
	
	$(".counter-container").find("input").unbind("click");
	$(".counter-container").find("input").click(function(e){
		e.preventDefault();
	});
	
	$(".counter-container").find(".btn.plus").unbind("click");
	$(".counter-container").find(".btn.plus").click(function(e){
		var counterContainer = $(this).closest('.counter-container');
		var currentValue = parseInt(counterContainer.find('input[product-code]:first').val());
		var minimumAmount = parseInt(counterContainer.attr('min-amount'));
		var newValue = roundValue(currentValue+minimumAmount, minimumAmount);
		if(counterContainer.find('form').length > 0){
			$(this).parent().submit();
		}else{
			$(this).closest('.counter-container').find('input[product-code]:first').val(newValue);
		}
		
		e.preventDefault();
	});
	
	//Prevent navigating to page when clicking on element to activate tooltip (mobile)
	$('[data-toggle="tooltip"]').unbind("click");
	$('[data-toggle="tooltip"]').click(function(e){ e.preventDefault();});
	
	//Product counter input change (basket only)
	var delayTimer;
	$(".counter-container input").keyup(function(e) {
		var input = $(this);
		var counterContainer = input.closest('.counter-container');
		var minimumAmount = parseInt(counterContainer.attr('min-amount'));
		
		clearTimeout(delayTimer);
		delayTimer = setTimeout(function() {
			input.val(roundValue(input.val(), minimumAmount));
			if(input.attr("update-basket-quantity-url") != undefined){
				updateBasketQuantity(input);
			}
		}, 800);
	});
	
	function updateBasketQuantity(input)
	{
		clearTimeout(delayTimer);
		delayTimer = setTimeout(function() {
			$.post(input.attr('update-basket-quantity-url') + '?productCode=' + encodeURIComponent(input.attr('product-code')) + '&quantity=' + input.val(), function(data) {
				location.reload(); 
			});
		}, 800);
	}
	
	//Add to basket
	$(".add-to-basket-btn").unbind("click");
	$(".add-to-basket-btn").click(function(e){
		var productCode = $(this).attr('product-code');
		var quantity = $(this).parent().find('input[product-code]:first').val();
		var modalContentTemplate = $("#modal-content-template").html();
		$.post('/api/basket/add/?productCode=' + encodeURIComponent(productCode) + '&quantity=' + quantity, function(data) {
			//Set modal data and show modal
			modalContentTemplate = modalContentTemplate
			.replace('{image}', data.image)
			.replace('{brandName}', data.brandName)
			.replace('{quantity}', data.quantity)
			.replace('{productCode}', data.productCode)
			.replace('{bruto}', data.bruto)
			.replace('{discount}', data.discount)
			.replace('{netto}', data.netto);
			
			$('#shopping-cart-modal').find(".modal-content").html(modalContentTemplate);
			$('#shopping-cart-modal').modal();

			//Set total
			if(parseInt(data.totalQuanity) > 0){
				$('.basket-total').html(data.totalQuanity);
				$('.basket-total').removeClass('hide');
			}else{
				$('.basket-total').addClass('hide');
			}
		});
		
		e.preventDefault();
	});
	
	//Get stock detail information
	$(".stock-detail-btn").unbind("click");
	$(".stock-detail-btn").click(function(e){
		var productCode = $(this).attr('product-code');
		
		$.get('/api/stock?productCode=' + encodeURIComponent(productCode) + '&basket=' + $(this).hasClass("basket"), function(data) {
			$('#stock-modal').find(".modal-body").html(data);
			$('#stock-modal').modal();
		});
		
		e.preventDefault()
	});
	
	//Favorite products
	$('.btn.favorite').unbind('click');
	$('.btn.favorite').click(function(e){
		$('[data-toggle="tooltip"]').tooltip("hide");
		
		var button = $(this);

		$.post('/api/addremovefavoriteproduct?productCode=' + encodeURIComponent(button.attr('product-code')), function(data) {
			if(data.productCode == null || data.productCode == ""){
				button.removeClass('favorited');
			}else{
				button.addClass('favorited');
			}
			
			//Set total
			if(parseInt(data.totalQuanity) > 0){
				$('.favorited-total').html(data.totalQuanity);
				$('.favorited-total').removeClass('hide');
			}else{
				$('.favorited-total').addClass('hide');
			}
			
			var title = button.attr("data-original-title");
			var alternativeTitle = button.attr("alternative-title");
			
			button.attr("data-original-title", alternativeTitle);
			button.attr("alternative-title", title);
			button.tooltip("show");
		});
		
		e.preventDefault();
	});
	
	//Product alerts
	$('.btn.alert-me').unbind('click');
	$('.btn.alert-me').click(function(e){
		$('[data-toggle="tooltip"]').tooltip("hide");
		
		var button = $(this);

		$.post('/api/addremoveproductalert?productCode=' + encodeURIComponent(button.attr('product-code')), function(data) {
			setTimeout(function(){ 
				if(data.productCode == null || data.productCode == ""){
					button.removeClass('alert-sheduled');
				}else{
					button.addClass('alert-sheduled');
				}

				var title = button.attr("data-original-title");
				var alternativeTitle = button.attr("alternative-title");
				
				button.attr("data-original-title", alternativeTitle);
				button.attr("alternative-title", title);
			}, 400);
		});
		
		e.preventDefault();
	});
	
	//Product ratings
	$('.product-rating').unbind('click');
	$('.product-rating').click(function(e){
		var score = $('[name="rating"]:checked').val();
		var productCode = encodeURIComponent($(this).attr('product-code'));

		$.post('/api/rateproduct?productCode=' + productCode + '&score=' + score, function(data) {});
	});
	
	$('.rating-label').unbind('click');
	$('.rating-label').click(function(e){
		$("#" + $(this).attr("for")).not(':checked').prop("checked", true);
	});
	
	bindComparatorEvents();
}